'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reBase = require('re-base');

var Rebase = _interopRequireWildcard(_reBase);

var _app = require('firebase/app');

var _app2 = _interopRequireDefault(_app);

require('firebase/database');

require('firebase/auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var firekit = void 0;

exports.default = function (conf) {
  if (firekit) {
    return firekit;
  }

  var app = conf.apiKey ? initializeApp(conf) : conf;
  firekit = init(app);

  return firekit;
};

function initializeApp(conf) {
  if (!conf) {
    throw new Error('Attempting to initialise firekit without a configuration. Do you need to create a class to initialise firekit in your app?');
  }
  return _app2.default.initializeApp(conf);
}

function init(app) {
  var database = app.database();
  var rebase = Rebase.createClass(database);
  var auth = app.auth();
  return {
    app: app,
    database: database,
    rebase: rebase,
    auth: auth,
    TIMESTAMP: _app2.default.database.ServerValue.TIMESTAMP
  };
}